import { render, staticRenderFns } from "./uppy_car_avatar.vue?vue&type=template&id=9b89adf0&scoped=true"
import script from "./uppy_car_avatar.vue?vue&type=script&lang=js"
export * from "./uppy_car_avatar.vue?vue&type=script&lang=js"
import style0 from "./uppy_car_avatar.vue?vue&type=style&index=0&id=9b89adf0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b89adf0",
  null
  
)

export default component.exports